"use client";
//import react
import React, { useState } from "react";
// External Lib
import { Box } from "@mui/material";
// Internal Lib
import { Label, Textarea, FormBox } from "@int-traderjoes/ui-components-library";
// Services
import AuthService from "@/services/authService";
// context
import { useTheme } from "@/context";
import { useFormContext } from "@/context/FormContext";
import { useLanguageContext } from "@/context/LanguageContext";


const ADDR_RECORDS_COUNT = process.env.NEXT_PUBLIC_MELISSA_ADDRESS_SUGGESTIONS_DEFAULT_COUNT ?? '10';
interface NotesForRevisionFormProps {
  isExpanded: boolean;
  onToggle: () => void;
  isFormDisabled?: boolean;
}

const NotesForRevisionForm: React.FC<NotesForRevisionFormProps> = ({
  isExpanded,
  onToggle,
  isFormDisabled
}) => {
  const { darkMode } = useTheme();
  const displayMode = () => {
    if (darkMode) {
      return "dark";
    } else {
      return "light";
    }
  };
  const {
    vendorAssessmentForm
  } = useFormContext();
  const { languageText } = useLanguageContext();
  const notesForRevisionInformationLabels = languageText?.LABELS?.VENDOR_INFORMATION?.NOTES_FOR_REVISION;
  const formHeader = languageText?.TABLE_AND_FORM_HEADER?.FORM_HEADER?.NOTES_FOR_REVISION;

  let notesForRevisionFormPermissions: any = {};


  // Fetching field permissions
  notesForRevisionFormPermissions = AuthService.fetchPermissions("vendorNotesForRevisionInformation");


  return (
    <FormBox
      title={formHeader}
      darkModeClass={displayMode()}
      collapsable={true}
      collapsed={!isExpanded}
      toggleCollapse={onToggle}
    >
      {isExpanded && (
          <Box className="w-full">
            <Label
              className={`${darkMode ? "dark" : "light"}`}
              text={notesForRevisionInformationLabels?.NOTES}
              htmlFor="notes"
              required={
                notesForRevisionFormPermissions.notes
                  .isMandatory
              }
            />
            <Textarea
              className={`${darkMode ? "dark" : "light"}`}
              value={vendorAssessmentForm?.vendorAssessmentRevisionNote ?? ""}
              disabled={
                !notesForRevisionFormPermissions.notes
                  ?.isEditable || isFormDisabled
              }
            />
        </Box>
      )}
    </FormBox>
  );
};

export default NotesForRevisionForm;